<template>
  <div class="proofing">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">打样管理</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>基地&nbsp;&nbsp;</span>
            <el-select v-model="fishBaseId" filterable placeholder="请选择" size="small" @change="baseChange">
              <el-option v-for="(item, index) in baseList" :key="index" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>时间&nbsp;&nbsp;</span>
            <el-date-picker size="small" v-model="start" type="date" :clearable="false" placeholder="开始日期" @change="changeTime(0)" value-format="yyyy-MM-dd"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box" style="padding: 0 5px">
            <span>至</span>
          </div>
          <div class="select-container-box" style="padding: 0 1px">
            <el-date-picker size="small" v-model="end" type="date" :clearable="false" placeholder="结束日期" value-format="yyyy-MM-dd" @change="changeTime(1)"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <!-- <div class="select-container-box">
            <span>在&nbsp;&nbsp;</span>
            <el-select v-model="type" filterable placeholder="请选择" size="small">
              <el-option v-for="(item, index) in typeList" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>查找&nbsp;&nbsp;</span>
            <el-input placeholder="请输入关键字" v-model="keyWord" :maxlength="num" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" prefix-icon="el-icon-search"
              size="small" class="search-input" clearable>
            </el-input>
          </div> -->
          <el-popover class="pop-condition" placement="bottom" width="580" v-model="popoverVisible" trigger="click">
            <div class="condition">
              <section class="mask">
                <div class="popover-container-box">
                  <span class="popover-label">塘口：</span>
                  <el-input placeholder="请输入" v-model="pondNo" :maxlength="num" size="small" class="search-input" clearable>
                  </el-input>
                </div>
                <div class="popover-container-box">
                  <span class="popover-label">品种：</span>
                  <el-input placeholder="请输入" v-model="fish" :maxlength="num" size="small" class="search-input" clearable></el-input>
                </div>
              </section>
              <div class="comfirm">
                <span @click="popoverVisible = false">关闭</span>
                <span @click="search(1)">查询</span>
              </div>
            </div>
            <div class="more" slot="reference">更多条件</div>
          </el-popover>
          <div class="select-container-box">
            <el-button size="small" type="info" plain @click="search(1)" class="query">查询</el-button>
            <el-button size="small" type="info" plain @click="add" class="add" v-if="edit">增加</el-button>
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table :data="proofingList.list" style="width: 100%" size="medium" @row-dblclick="dataBackFillGoods" :summary-method="getSummaries"
          :default-sort="{ prop: 'date', order: 'descending' }" show-summary>
          <i slot="empty" style="font-style: normal">该时间段暂无数据</i>
          <el-table-column prop="date" label="日期" align="center" width="100" :formatter="formatter">
          </el-table-column>
          <el-table-column prop="pondName" label="塘口" align="center" show-overflow-tooltip :filters="getPondFilterList" :filter-method="filterHandler">
          </el-table-column>
          <el-table-column prop="fishBatchNo" label="周期" v-if="false" width="80" show-overflow-tooltip align="center" :filters="getPeriodFilterList" :filter-method="filterHandler">
          </el-table-column>
          <el-table-column prop="fishName" label="品种" align="center" show-overflow-tooltip :filters="getFishFilterList" :filter-method="filterHandler">
          </el-table-column>
          <el-table-column prop="unit" label="计量单位" width="90" show-overflow-tooltip align="center">
          </el-table-column>
          <el-table-column prop="weight" align="center" show-overflow-tooltip label="打样总斤数" sortable>
          </el-table-column>
          <el-table-column prop="quantity" label="打样数量" show-overflow-tooltip align="center" sortable>
          </el-table-column>
          <el-table-column prop="avgWeight" label="均重" width="120" show-overflow-tooltip align="center">
          </el-table-column>
          <el-table-column prop="survivalRate" label="预估存活率(%)" show-overflow-tooltip align="center">
          </el-table-column>
          <el-table-column prop="avgBodyLen" show-overflow-tooltip label="平均体长(cm)" align="center">
          </el-table-column>
          <el-table-column prop="ownerName" show-overflow-tooltip align="center" width="110" label="制单人">
          </el-table-column>
          <el-table-column label="操作栏" align="center" width="110">
            <template slot-scope="scope">
              <span class="content-edit" @click="handleEdit(scope.$index, scope.row)">{{ edit ? "编辑" : "查看" }}</span>
              <span class="content-del" @click="handleDelete(scope.$index, scope.row)" v-if="edit">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
    </div>
  </div>
</template>

<script>
import PageChange from "../../common/PageChange";
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { storage } from "../../../service/storage";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
import { resolveFishBaseKeyFromList, fishBaseIdForQuery } from "@/common/resolveFishBaseSelection.js";
export default {
  name: "proofingManagement",
  mixins: [mixins],
  components: {
    PageChange,
  },
  data () {
    return {
      popoverVisible: false,
      num: 20,
      fishBaseId: "", //基地
      baseList: [], //基地列表
      rowId: "",
      type: "",
      typeList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "pondNo",
          label: "所在塘口",
        },
        // {
        //   value: "fishBatch",
        //   label: "周期"
        // },
        {
          value: "fish",
          label: "品种",
        },
      ],
      start: "", //开始时间
      end: "", //结束时间
      pickerTimeOptions: {
        // 限制日期
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      keyWord: "", //查找
      pondNo: "",
      fish: "",
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10, // 当前页数
      },
    };
  },
  methods: {
    ...mapActions(modules.proofing, [
      "getProofingData", //查询数据
      "delProofingDetail", //删除
    ]),
    ...mapActions(modules.base, [
      "getAllBaseList", //基地信息
    ]),
    //记住基地
    baseChange (e) {
      storage.set("base", e);
    },
    //存储选中时间
    changeTime (type) {
      if (type == 0) {
        storage.set("start", this.start);
      } else {
        storage.set("end", this.end);
      }
    },
    //双击进入编辑页面
    dataBackFillGoods (row, event) {
      this.$router.push({
        name: "addProofing",
        query: {
          id: row.orderId,
        },
      });
    },
    //合计显示格式
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (
          index === 1 ||
          index === 2 ||
          index === 4 ||
          index === 3 ||
          index === 7 ||
          index === 8 ||
          index === 9
        ) {
          sums[index] = "--";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2) + " ";
        } else {
          sums[index] = "--";
        }
      });
      return sums;
    },
    // 筛选过滤
    filterHandler (value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    // 格式化指定列时间
    formatter (row) {
      if (!row.date) {
        return false;
      }
      return this.$timeformatDay(row.date);
    },
    //查询数据
    search (pageNum) {
      // 设置sessionStorage
      sessionStorage.setItem("profingKeyword", this.keyWord);
      let obj = {
        pageIndex: (this.pageInfo.pageNumber = pageNum || 1),
        pageSize: this.pageInfo.pageSize,
        fishBaseId: fishBaseIdForQuery(this.fishBaseId, this.baseList),
        startDate: this.start,
        endDate: this.end,
        fish: this.fish,
        fishBatch: this.fishBatch,
        pondNo: this.pondNo,
      };
      // if (this.type === "") {
      //   obj.fish = this.keyWord;
      //   obj.fishBatch = this.keyWord;
      //   obj.pondNo = this.keyWord;
      // } else {
      //   obj[this.type] = this.keyWord;
      // }

      this.getProofingData(obj)
        .then((rsp) => {
          if (rsp.status === 200) {
            this.pageInfo.totalPages = rsp.data.total;
          }
        })
        .catch((err) => {
          console.dir(err);
        });
      
      this.popoverVisible = false
    },
    //导出
    out () { },
    //添加
    add () {
      this.$router.push({
        name: "addProofing",
        query: {
        },
      });
    },
    //编辑
    handleEdit (index, row) {
      this.$router.push({
        name: "addProofing",
        query: {
          id: row.orderId,
        },
      });
    },
    //删除
    handleDelete (index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.delProofingDetail(row.id);
          this.search(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch((err) => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error",
          });
        });
    },
  },
  computed: {
    ...mapState(modules.proofing, ["proofingList"]),
    getPondFilterList () {
      const res = new Map();
      let fiterList = this.proofingList.list
        .map((m) => ({
          value: m.pondName,
          text: m.pondName,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    getPeriodFilterList () {
      const res = new Map();
      let fiterList = this.proofingList.list
        .map((m) => ({
          value: m.fishBatchNo,
          text: m.fishBatchNo,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    getFishFilterList () {
      const res = new Map();
      let fiterList = this.proofingList.list
        .map((m) => ({
          value: m.fishName,
          text: m.fishName,
        }))
        .filter((a) => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
  },
  async mounted () {
    // sessionstorage记住查找关键字
    this.judgeSession("profingKeyword");
    this.keyWord = this.word;
    //基地信息
    this.baseList = await this.getAllBaseList({ forQueryAll: true });
    this.fishBaseId = resolveFishBaseKeyFromList(
      this.baseList,
      storage.get("base")
    );
    this.search(1); //查询
  },
  //缓存路由组件重新被激活 事件，重新查询列表数据
  activated () {
    this.search(this.pageInfo.pageNumber);
  },
  //默认时间
  created () {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.start = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      this.start = this.$timeformatDay(start);
    }
    if (endTime) {
      this.end = endTime;
    } else {
      this.end = this.$timeformatDay(new Date());
    }
  },
};
</script>
<style lang="stylus" scoped>
.pop-condition {
  .more {
    margin-left: 20px;
    padding: 0 20px;
    line-height: 32px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(230, 230, 230, 1));
    border: 1px solid rgba(198, 198, 198, 1);
    border-radius: 4px;
    color: #333333;
    cursor: pointer;
  }
}

.el-popover {
  width: 580px !important;

  .unit {
    display: inline-block;
    line-height: 32px;
    width: 180px;
    text-align: left;
  }

  .condition {
    color: #333;
    font-size: 16px;

    .more {
      height: 32px;
      padding: 0 12px;
      border-radius: 5px;
      line-height: 32px;
      font-size: 14px;
      color: #333;
      cursor: pointer;
      background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(230, 230, 230, 1));
      border: 1px solid rgba(198, 198, 198, 1);
    }
  }

  .mask {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 5px 20px 15px 20px;
    z-index: 20;
    font-size: 16px;
    color: #666;
    background: #fff;

    .more {
      margin-left: 20px;
    }

    .popover-container-box {
      width: 260px;
      margin-top: 15px;
      display: flex;

      .popover-label {
        width: 100px;
      }
    }

    .el-input__inner {
      height: 36px;
      width: 180px;
    }

    >div {
      &:nth-child(2n) {
        text-align: right;
        padding-left: 0;

        >span {
          width: 80px;
          text-align: right;
        }
      }
    }
  }

  .comfirm {
    text-align: center;
    font-size: 16px;

    >span {
      display: inline-block;
      width: 100px;
      margin: 15px 0;
      border: 1px solid #BBBBBB;
      border-radius: 4px;
      line-height: 36px;
      background: #fff;
      cursor: pointer;

      &:nth-child(2) {
        margin-left: 20px;
        border: 1px solid #3389FF;
        color: #fff;
        background: #3389FF;
      }
    }
  }
}
</style>
